import React from "react";
import CircularProgressbar from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import StatsUtils from "../../../../../utils/stats";
import CountUp from "react-countup";
import DoughnutProvider from "./DoughnutProvider";

const Doughnuts = props => {
  const trend = -1;
  const color = props.color ? props.color : trend === 1 ? "#54CD98" : trend === -1 ? "#DB1E08" : "#FEA701";
  const value = props.newestPercentage || 0;

  const kpi = props.kpi || {};
  const size = props.size || null;
  const style = props.style || {};
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const styleChrome = { maxWidth: "150px", minWidth: size == "small" ? "100px" : "150px" };
  const styleSafari = { maxWidth: "100px", minWidth: size == "small" ? "100px" : "100px" };

  return (
    <div className="p-al-r-center p-w-h-100" style={isSafari ? styleSafari : styleChrome}>
      <div id={props._id} style={{ position: "relative", ...style }}>
        <DoughnutProvider values={[0, value]}>
          {percentage => (
            <CircularProgressbar
              percentage={percentage}
              styles={{
                path: {
                  transition: percentage === 0 ? "none" : "stroke-dashoffset 3s ease 0s",
                  stroke: `${color}`
                }
              }}
            />
          )}
        </DoughnutProvider>

        <div
          className="p-al-c-full-center p-w-h-100"
          style={{
            position: "absolute",
            top: isSafari && size !== "small" && !props.fixSafari ? -45 : 1,
            maxWidth: "150px" /*minWidth: size == "small" ? "100px" : "150px"*/
          }}
        >
          <div className="p-al-c-full-center">
            <div
              style={{
                fontSize: size == "small" ? 14 : "2.5vh",
                fontWeight: "bold"
                //marginTop: "7%"
              }}
            >
              <CountUp
                start={0}
                end={StatsUtils.roundKpiValue(kpi, value)}
                duration={3}
                separator=" "
                style={{
                  fontSize: size == "small" ? 14 : "2.5vh"
                }}
                decimals={value % 1 === 0 ? 0 : 2}
                formattingFn={v => {
                  return StatsUtils.formatKpiValue(kpi, v);
                }}
              />
            </div>
            {props.circleTitle ? <div className="p-stats-home-item-title">{props.circleTitle}</div> : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Doughnuts;



// WEBPACK FOOTER //
// src/modules/stats/containers/summary/Global/Doughnut.js